import React, { useContext } from 'react';
import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { useAudioFeatureFlags } from '@confluence/audio/entry-points/useAudioFeatureFlags.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { PageCardContext } from '../PageCardContext.ts';

const WrappedButton = ({ flags, isEndOfPage }) => {
	const { cloudId } = useSessionData();
	const { isAudioV3Enabled } = useAudioFeatureFlags();
	const { id, type, title } = useContext(PageCardContext);

	return (
		cloudId &&
		type === 'page' &&
		isAudioV3Enabled && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={id}
				contentType={type}
				title={title.text}
				subtle
				flagsOverride={flags}
				actionSource={isEndOfPage ? 'endOfPageRecommendations' : 'pageTree'}
			/>
		)
	);
};

export const AudioPlaylistButton = withFlags(WrappedButton);
